// extracted by mini-css-extract-plugin
module.exports = {"adminModeBanner":"AdminModeBanner_adminModeBanner__l38hR"};